
if (!window.__smzCustomSizeSyncLoaded) {
    window.__smzCustomSizeSyncLoaded = true;
    (function () {
        let customSizeRecordId = null;
        let customSizeDebounceTimer = null;
        let isCustomSizeCreating = false;
        let customSizeCreationPromise = null;
        let currentSessionId = 0;
        let currentPopupSessionKey = Date.now() + '_' + Math.floor(Math.random() * 1000000);

        function getStoredLocation() {
            try {
                return localStorage.getItem('location') || '';
            } catch (e) {
                return '';
            }
        }

        function isModalOpen() {
            const ov = document.getElementById('smzOverlay');
            return ov ? ov.classList.contains('open') : false;
        }

        function getSessionPaymentUrl() {
            const baseUrl = window.location.origin + window.location.pathname;
            const search = window.location.search;
            const sessionParam = 'popup_session=' + (currentPopupSessionKey || (Date.now() + '_' + Math.floor(Math.random() * 1000000)));
            if (!search) {
                return baseUrl + '?' + sessionParam;
            } else if (search.includes('popup_session=')) {
                return baseUrl + search.replace(/popup_session=[^&]+/, sessionParam);
            } else {
                return baseUrl + search + '&' + sessionParam;
            }
        }

        // Called after add-size-variant successfully completes — flags the
        // Airtable record with sent_to_at so the backend can branch on its presence.
        window.markCustomSizeSentToAt = function () {
            const recordId = customSizeRecordId;
            if (!recordId) return;

            try {
                fetch('https://webhooks.codeblue.agency/api/custom-size/update', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    },
                    keepalive: true,
                    body: JSON.stringify({
                        record_id: recordId,
                        sent_to_at: true,
                        location: getStoredLocation(),
                        project: 'QuickSignage'
                    })
                }).then(function (response) {
                    return response.json().catch(function () { return null; });
                }).then(function (result) {
                    console.log('[Custom Size Sync] Marked sent_to_at for Airtable Record ID:', recordId, result);
                }).catch(function (err) {
                    console.error('[Custom Size Sync sent_to_at Exception]:', err);
                });
            } catch (err) {
                console.error('[Custom Size Sync sent_to_at Exception]:', err);
            }
        };

        function getCustomSizeFormData() {
            const wEl = document.getElementById("smzWidth");
            const hEl = document.getElementById("smzHeight");
            const wVal = wEl ? wEl.value.trim() : '';
            const hVal = hEl ? hEl.value.trim() : '';

            const activeTab = document.querySelector('.smz-type-tab.active');
            const signTypeVal = activeTab ? activeTab.textContent.trim() : (SMZ.type || '');

            const priceVal = (SMZ.staged && SMZ.staged.price) ? SMZ.staged.price : (window.lastCalculatedFinalPrice || null);

            let widthNum = wVal && !isNaN(parseFloat(wVal)) ? parseFloat(wVal) : null;
            let heightNum = hVal && !isNaN(parseFloat(hVal)) ? parseFloat(hVal) : null;

            // Picking a preset clears the free-text width/height inputs (the
            // dims live only on SMZ.staged), so fall back to the staged
            // preset's dims here — otherwise a preset sync sends null width/
            // height even though a price was captured.
            if ((widthNum === null || heightNum === null) && SMZ.staged && SMZ.staged.width != null && SMZ.staged.height != null) {
                widthNum = SMZ.staged.width;
                heightNum = SMZ.staged.height;
            }

            return {
                type_of_sign: signTypeVal ? String(signTypeVal).trim() : '',
                width_in: widthNum,
                height_in: heightNum,
                final_price: priceVal ? parseFloat(priceVal) : null,
                payment_url: getSessionPaymentUrl(),
                location: getStoredLocation(),
                project: 'QuickSignage'
            };
        }

        async function syncCustomSizeData(sessionId) {
            if (sessionId !== currentSessionId || !isModalOpen()) {
                return;
            }

            if (isCustomSizeCreating && customSizeCreationPromise) {
                try {
                    await customSizeCreationPromise;
                } catch (e) { }
            }

            if (sessionId !== currentSessionId || !isModalOpen()) {
                return;
            }

            const data = getCustomSizeFormData();

            if (!data.width_in || !data.height_in || isNaN(data.width_in) || isNaN(data.height_in) || data.width_in <= 0 || data.height_in <= 0) {
                return;
            }

            const doFetch = async () => {
                if (sessionId !== currentSessionId || !isModalOpen()) {
                    return;
                }

                const isUpdate = Boolean(customSizeRecordId);
                const endpoint = isUpdate
                    ? 'https://webhooks.codeblue.agency/api/custom-size/update'
                    : 'https://webhooks.codeblue.agency/api/custom-size/create';

                const payload = {
                    ...data,
                    project: 'QuickSignage'
                };

                if (isUpdate && customSizeRecordId) {
                    payload.record_id = customSizeRecordId;
                }

                try {
                    const response = await fetch(endpoint, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify(payload)
                    });

                    if (sessionId !== currentSessionId || !isModalOpen()) {
                        return;
                    }

                    const result = await response.json();

                    if (sessionId !== currentSessionId || !isModalOpen()) {
                        return;
                    }

                    if (response.ok && result.success) {
                        if (!customSizeRecordId && result.record_id) {
                            customSizeRecordId = result.record_id;
                            console.log('[Custom Size Live Sync] Created Airtable Record ID:', customSizeRecordId);
                        } else {
                            console.log('[Custom Size Live Sync] Updated Airtable Record ID:', customSizeRecordId);
                        }
                        return result;
                    } else {
                        console.error('[Custom Size Live Sync Error]:', result);
                    }
                } catch (err) {
                    if (sessionId === currentSessionId && isModalOpen()) {
                        console.error('[Custom Size Live Sync Exception]:', err);
                    }
                }
            };

            const initialRecordId = customSizeRecordId;
            if (!initialRecordId && !isCustomSizeCreating) {
                isCustomSizeCreating = true;
                customSizeCreationPromise = doFetch().finally(() => {
                    if (sessionId === currentSessionId) {
                        isCustomSizeCreating = false;
                        customSizeCreationPromise = null;
                    }
                });
                return customSizeCreationPromise;
            } else {
                return doFetch();
            }
        }

        function handleCustomSizeInput() {
            if (!isModalOpen()) return;
            clearTimeout(customSizeDebounceTimer);
            const thisSessionId = currentSessionId;
            const delay = customSizeRecordId ? 2000 : 500;
            customSizeDebounceTimer = setTimeout(() => {
                syncCustomSizeData(thisSessionId);
            }, delay);
        }

        document.addEventListener('input', (e) => {
            if (
                e.target &&
                (e.target.id === 'smzWidth' ||
                    e.target.id === 'smzHeight' ||
                    e.target.closest('#smzModal, #smzOverlay, .smz-card'))
            ) {
                handleCustomSizeInput();
            }
        });

        document.addEventListener('change', (e) => {
            if (
                e.target &&
                (e.target.id === 'smzWidth' ||
                    e.target.id === 'smzHeight' ||
                    e.target.closest('#smzModal, #smzOverlay, .smz-card'))
            ) {
                handleCustomSizeInput();
            }
        });

        document.addEventListener('click', (e) => {
            if (e.target && e.target.closest('.smz-type-tab, .smz-preset, #smzGetPrice, #smzPresetGrid')) {
                handleCustomSizeInput();
            }
        });

        window.triggerCustomSizeAutoSync = function (finalPrice) {
            if (!isModalOpen()) return;
            if (finalPrice) {
                window.lastCalculatedFinalPrice = finalPrice;
            }
            handleCustomSizeInput();
        };

        window.resetCustomSizeLiveSync = function () {
            currentSessionId++;
            currentPopupSessionKey = Date.now() + '_' + Math.floor(Math.random() * 1000000);
            customSizeRecordId = null;
            isCustomSizeCreating = false;
            customSizeCreationPromise = null;
            window.lastCalculatedFinalPrice = null;
            clearTimeout(customSizeDebounceTimer);
        };

        // Called on modal close: stops any further syncing immediately, then
        // sends a final "complete" signal for the record created during this
        // session (if any) so Airtable reflects a finished session rather than
        // a silently abandoned one.
        window.finalizeCustomSizeSession = async function () {
            currentSessionId++;
            clearTimeout(customSizeDebounceTimer);

            if (isCustomSizeCreating && customSizeCreationPromise) {
                try { await customSizeCreationPromise; } catch (e) { }
            }

            const recordIdToFinalize = customSizeRecordId;
            if (recordIdToFinalize) {
                try {
                    const response = await fetch('https://webhooks.codeblue.agency/api/custom-size/update', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        keepalive: true,
                        body: JSON.stringify({
                            record_id: recordIdToFinalize,
                            status: 'Completed',
                            location: getStoredLocation(),
                            project: 'QuickSignage'
                        })
                    });
                    const result = await response.json();
                    if (response.ok && result.success) {
                        console.log('[Custom Size Live Sync] Finalized Airtable Record ID:', recordIdToFinalize);
                    } else {
                        console.error('[Custom Size Live Sync Error] Finalize failed:', result);
                    }
                } catch (err) {
                    console.error('[Custom Size Live Sync Exception] Finalize failed:', err);
                }
            }

            currentPopupSessionKey = Date.now() + '_' + Math.floor(Math.random() * 1000000);
            customSizeRecordId = null;
            isCustomSizeCreating = false;
            customSizeCreationPromise = null;
            window.lastCalculatedFinalPrice = null;
        };
    })();
}
